import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  loadVideos,
  selectCategories,
  selectVideos,
  selectGroups,
  selectSocialCard,
} from '../../utils/redux/store/videos';
import { getContentfulLocale } from '../../../features/src/i18n/locales';
import { useLocale } from '../../../features/src/i18n';

// Define a custom hook to encapsulate the Redux logic
export const useReduxVideos = () => {
  const dispatch = useDispatch();
  const locale = useLocale();
  useEffect(() => {
    dispatch(loadVideos({ smartlingLanguage: getContentfulLocale(locale) }));
  }, [dispatch, locale]);

  const videoCategories = useSelector(selectCategories);
  const videos = useSelector(selectVideos);
  const videoGroups = useSelector(selectGroups);
  const socialCard = useSelector(selectSocialCard);

  return { videoCategories, videos, videoGroups, socialCard };
};
